var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMyAccountWithdrawal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_22111",
    "data-name": "Group 22111",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 19.591,
    height: 19.584,
    viewBox: "0 0 19.591 19.584",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9350",
    "data-name": "Rectangle 9350",
    width: 19.591,
    height: 19.584,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_22111-2",
    "data-name": "Group 22111",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16151",
    "data-name": "Path 16151",
    d: "M195.652,68.541c0,.083-.006.165-.006.248q0,6.8,0,13.592h-5.163a.323.323,0,0,1-.061-.233q0-.958,0-1.917a.354.354,0,0,1,.049-.218.426.426,0,0,1,.31-.062c.745,0,1.49,0,2.236,0,.26,0,.273-.014.273-.267q0-.831,0-1.662c0-.226-.017-.241-.237-.243-.2,0-.395,0-.592,0-.136,0-.2.056-.2.193,0,.236.007.471,0,.707-.009.189-.055.239-.245.243-.452.01-.9.006-1.357,0a.272.272,0,0,1-.18-.052.257.257,0,0,1-.054-.178c0-.658-.007-1.317,0-1.975a.334.334,0,0,1,.016-.093c.041-.107.138-.1.225-.107a2.912,2.912,0,0,0,1.3-.424,2.8,2.8,0,0,0,.752-4.1,2.757,2.757,0,0,0-2.039-1.105c-.086-.007-.184,0-.23-.1a1.126,1.126,0,0,1-.024-.34q0-.807,0-1.613a.474.474,0,0,1,.051-.294.326.326,0,0,1,.235-.059c.42,0,.841,0,1.261,0,.244,0,.287.049.293.294.005.216,0,.433,0,.649,0,.131.046.2.188.2.223,0,.446,0,.669,0,.122,0,.169-.059.169-.176,0-.6,0-1.21,0-1.815,0-.182-.117-.182-.244-.182-.751,0-1.5,0-2.254,0a.484.484,0,0,1-.314-.054.24.24,0,0,1-.053-.16c-.007-.279-.008-.559,0-.839a.241.241,0,0,1,.053-.16.415.415,0,0,1,.275-.055q2.319,0,4.638,0a.426.426,0,0,1,.258.049.314.314,0,0,1,.055.217q0,.936,0,1.872a.321.321,0,0,1-.054.218",
    transform: "translate(-180.688 -62.802)",
    fill: "#8bbf56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16152",
    "data-name": "Path 16152",
    d: "M94.647,68.546v2.294l-.021.021c-.2.047-.415.054-.619.1a2.813,2.813,0,0,0,.244,5.528,1.808,1.808,0,0,1,.375.061l.021.021V78.87l-.027.025a.375.375,0,0,1-.186.034c-.426,0-.853,0-1.279,0-.235,0-.28-.05-.287-.28s0-.446,0-.668c0-.134-.054-.2-.193-.2-.223,0-.446,0-.668,0-.109,0-.164.049-.164.161q0,.926,0,1.852c0,.162.114.159.225.159.751,0,1.5,0,2.254,0a.65.65,0,0,1,.3.034l.027.025q0,1.185,0,2.371H89.485q0-6.806,0-13.612c0-.076,0-.152-.006-.229a.346.346,0,0,1-.054-.236q0-.913,0-1.827a.231.231,0,0,1,.306-.292q2.333,0,4.665,0a.425.425,0,0,1,.223.039l.026.028q0,.571,0,1.141l-.027.025a.6.6,0,0,1-.281.035h-2.2c-.3,0-.3,0-.3.311,0,.541,0,1.082,0,1.623,0,.221.018.237.241.239.2,0,.395,0,.592,0,.139,0,.193-.062.193-.2,0-.235,0-.471,0-.706,0-.14.055-.236.21-.239.484-.008.967-.012,1.451,0a.206.206,0,0,1,.091.027l.027.025",
    transform: "translate(-84.852 -62.807)",
    fill: "#b4ca1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16153",
    "data-name": "Path 16153",
    d: "M4.731,3.525q0,1.144-.006,2.288H.1V.077H9.895a.275.275,0,0,1,.059.2q0,.961,0,1.921a.384.384,0,0,1-.026.149.123.123,0,0,1-.05.055.814.814,0,0,1-.339.033H2.752c-.231,0-.25.022-.253.252,0,.185,0,.37,0,.554s.023.216.224.217c.573,0,1.147,0,1.72,0,.1,0,.207-.021.287.066",
    transform: "translate(-0.099 -0.073)",
    fill: "#eff3f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16154",
    "data-name": "Path 16154",
    d: "M191.615,2.293q0-1.145,0-2.289,4.78,0,9.559,0c.181,0,.236.044.235.23q-.011,2.638,0,5.275c0,.2-.064.238-.248.237-1.459-.007-2.919,0-4.378,0q0-1.144-.006-2.288c.081-.087.188-.066.287-.066.547,0,1.1,0,1.643,0,.3,0,.3,0,.3-.312,0-.178,0-.356,0-.535,0-.118-.055-.175-.174-.176l-.21,0q-3.333,0-6.666,0c-.117,0-.245.032-.345-.064",
    transform: "translate(-181.821 0)",
    fill: "#d8e0ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16155",
    "data-name": "Path 16155",
    d: "M190.486,157.156a2.868,2.868,0,1,1,0,5.735h0a.352.352,0,0,1-.061-.253q0-2.615,0-5.23a.352.352,0,0,1,.061-.253Z",
    transform: "translate(-180.691 -149.122)",
    fill: "#57a452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16156",
    "data-name": "Path 16156",
    d: "M190.467,44.868l4.777,0c.841,0,1.682,0,2.523,0,.118,0,.167.021.162.154-.011.28-.01.561,0,.84,0,.125-.032.159-.157.158-.682-.006-1.363,0-2.045,0-.032,0-.063,0-.1.006q-1.649,0-3.3-.006c-.623,0-1.245,0-1.868.005l.006-.011a.152.152,0,0,1-.051-.1,7.554,7.554,0,0,1,0-.94.151.151,0,0,1,.051-.1Z",
    transform: "translate(-180.673 -42.575)",
    fill: "#302f54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16157",
    "data-name": "Path 16157",
    d: "M190.487,89.777c.885,0,1.77,0,2.655,0,.161,0,.221.032.218.208-.011.636-.008,1.273,0,1.91,0,.144-.041.189-.184.183-.261-.01-.522-.01-.783,0-.14.005-.193-.033-.186-.18.011-.261-.006-.522.007-.783.008-.158-.052-.192-.2-.19-.509.008-1.019,0-1.528,0h0a.236.236,0,0,1-.057-.157q-.01-.417,0-.834a.236.236,0,0,1,.057-.157Z",
    transform: "translate(-180.692 -85.185)",
    fill: "#57a452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16158",
    "data-name": "Path 16158",
    d: "M190.487,292.916c.509,0,1.019,0,1.528,0,.145,0,.2-.032.2-.19-.013-.267,0-.535-.005-.8,0-.108.022-.164.147-.161.286.007.573.006.859,0,.107,0,.145.036.144.143,0,.668-.005,1.337,0,2.005,0,.143-.071.149-.178.148q-1.347,0-2.693,0h0a.236.236,0,0,1-.057-.157q-.01-.417,0-.834a.236.236,0,0,1,.057-.157Z",
    transform: "translate(-180.692 -276.853)",
    fill: "#57a452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16159",
    "data-name": "Path 16159",
    d: "M138.362,157.155v5.736a2.868,2.868,0,1,1,0-5.736",
    transform: "translate(-128.566 -149.122)",
    fill: "#8bbf56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16160",
    "data-name": "Path 16160",
    d: "M53.129,44.926q0,.568,0,1.136l-4.918.005c-.082,0-.165,0-.247.006-.707,0-1.414-.009-2.12,0-.144,0-.184-.037-.178-.179.012-.28.007-.56,0-.84,0-.095.019-.133.125-.133q3.668.007,7.337.008",
    transform: "translate(-43.331 -42.622)",
    fill: "#4d427b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16161",
    "data-name": "Path 16161",
    d: "M138.345,89.817v1.148c-.509,0-1.019,0-1.528,0-.146,0-.2.033-.2.19.013.267,0,.535.005.8,0,.108-.022.164-.147.16-.286-.007-.573-.006-.86,0-.107,0-.145-.035-.144-.143,0-.668.005-1.337,0-2.005,0-.142.069-.149.177-.149q1.347,0,2.694,0",
    transform: "translate(-128.549 -85.225)",
    fill: "#8bbf56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16162",
    "data-name": "Path 16162",
    d: "M138.324,292.9v1.148c-.892,0-1.783,0-2.675,0-.144,0-.2-.03-.2-.189.009-.643.008-1.286,0-1.929,0-.144.042-.188.184-.182.261.01.522.01.783,0,.139-.005.193.033.186.18-.011.267,0,.535-.006.8,0,.138.047.172.176.17.516-.006,1.032,0,1.547,0",
    transform: "translate(-128.528 -276.833)",
    fill: "#8bbf56"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyAccountWithdrawal);
export default __webpack_public_path__ + "static/media/my-account-withdrawal.e58e8d2136242bfc3cc33802bdd259e1.svg";
export { ForwardRef as ReactComponent };